module.exports = __webpack_public_path__ + "static/media/35.65d87e7b.jpg";